import { MutationCache, QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 0, refetchOnWindowFocus: true },
		mutations: { retry: 0 },
	},
	mutationCache: new MutationCache({
		onSuccess: () => {
			queryClient.invalidateQueries({ type: 'active' })
		},
	}),
})
